import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, isRef as _isRef, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, vModelCheckbox as _vModelCheckbox, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "mt-8" }
const _hoisted_2 = { class: "mt-10 mb-4" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", {
  for: "country",
  class: "block mb-2 text-sm font-medium text-gray-900"
}, [
  /*#__PURE__*/_createTextVNode("User Type "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-red-500" }, "*")
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("option", { selected: "" }, "Please select", -1)
const _hoisted_5 = ["value"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("hr", { class: "bg-play-light-gray" }, null, -1)
const _hoisted_7 = { class: "mt-6" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("h2", { class: "font-medium text-3xl leading-[48px] tracking-normal capitalize" }, "Profile Information", -1)
const _hoisted_9 = { class: "flex flex-wrap mt-6 space-y-2 md:space-y-0 md:space-x-3 md:flex-nowrap" }
const _hoisted_10 = { class: "w-full md:w-1/2" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", {
  for: "firstname",
  class: "block mb-2 text-sm font-medium text-gray-900"
}, [
  /*#__PURE__*/_createTextVNode("First Name "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-red-500" }, "*")
], -1)
const _hoisted_12 = { class: "w-full md:w-1/2" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", {
  for: "lastname",
  class: "block mb-2 text-sm font-medium text-gray-900"
}, [
  /*#__PURE__*/_createTextVNode("Last Name "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-red-500" }, "*")
], -1)
const _hoisted_14 = { class: "flex flex-wrap mt-2 space-y-2 md:mt-6 md:space-y-0 md:space-x-3 md:flex-nowrap" }
const _hoisted_15 = { class: "w-full md:w-1/2" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", {
  for: "email-address",
  class: "block mb-2 text-sm font-medium text-gray-900"
}, [
  /*#__PURE__*/_createTextVNode("Trained By Organisation "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-red-500" }, "*")
], -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("option", {
  selected: "",
  disabled: "",
  value: "0"
}, "Please select", -1)
const _hoisted_18 = ["value"]
const _hoisted_19 = { class: "w-full md:w-1/2" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("label", {
  for: "sub_organisation",
  class: "block mb-2 text-sm font-medium text-gray-900"
}, [
  /*#__PURE__*/_createTextVNode("Organisation "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-red-500" })
], -1)
const _hoisted_21 = { class: "flex flex-wrap mt-2 space-y-2 md:mt-6 md:space-y-0 md:space-x-3 md:flex-nowrap" }
const _hoisted_22 = { class: "w-full md:w-1/2" }
const _hoisted_23 = {
  for: "email-address",
  class: "block mb-2 text-sm font-medium text-gray-900"
}
const _hoisted_24 = /*#__PURE__*/_createElementVNode("span", { class: "text-red-500" }, "*", -1)
const _hoisted_25 = { class: "w-full md:w-1/2" }
const _hoisted_26 = {
  for: "email-address",
  class: "block mb-2 text-sm font-medium text-gray-900 capitalize"
}
const _hoisted_27 = /*#__PURE__*/_createElementVNode("hr", { class: "mt-6 bg-play-light-gray" }, null, -1)
const _hoisted_28 = { class: "mt-2 space-y-2 md:space-y-0 md:space-x-3 md:flex-nowrap" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("h2", { class: "font-medium text-3xl leading-[48px] tracking-normal capitalize" }, "External Platforms", -1)
const _hoisted_30 = { class: "flex items-start pt-6 space-x-3" }
const _hoisted_31 = { class: "flex items-start pt-6 space-x-3" }
const _hoisted_32 = { class: "flex items-start pt-6 space-x-3" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("hr", { class: "mt-6 bg-play-light-gray" }, null, -1)
const _hoisted_34 = { class: "pb-16 mt-6" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("h2", { class: "font-medium text-3xl leading-[48px] tracking-normal capitalize" }, "Contact Address", -1)
const _hoisted_36 = { class: "flex flex-wrap mt-6 space-y-2 md:space-y-0 md:space-x-3 md:flex-nowrap" }
const _hoisted_37 = { class: "w-full md:w-1/2" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("label", {
  for: "addressLine1",
  class: "block mb-2 text-sm font-medium text-gray-900"
}, "Address Line 1", -1)
const _hoisted_39 = { class: "w-full md:w-1/2" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("label", {
  for: "addressLine2",
  class: "block mb-2 text-sm font-medium text-gray-900"
}, "Address Line 2", -1)
const _hoisted_41 = { class: "flex flex-wrap mt-6 space-y-2 md:space-y-0 md:space-x-3 md:flex-nowrap" }
const _hoisted_42 = { class: "w-full md:w-1/2" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("label", {
  for: "city",
  class: "block mb-2 text-sm font-medium text-gray-900"
}, "City", -1)
const _hoisted_44 = { class: "w-full md:w-1/2" }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("label", {
  for: "county",
  class: "block mb-2 text-sm font-medium text-gray-900"
}, "County / State", -1)
const _hoisted_46 = { class: "flex flex-wrap mt-6 space-y-2 md:space-y-0 md:space-x-3 md:flex-nowrap" }
const _hoisted_47 = { class: "w-full md:w-1/2" }
const _hoisted_48 = /*#__PURE__*/_createElementVNode("label", {
  for: "postcode",
  class: "block mb-2 text-sm font-medium text-gray-900"
}, "Postcode/ZIP", -1)
const _hoisted_49 = { class: "w-full md:w-1/2" }
const _hoisted_50 = /*#__PURE__*/_createElementVNode("label", {
  for: "country",
  class: "block mb-2 text-sm font-medium text-gray-900"
}, [
  /*#__PURE__*/_createTextVNode("Country "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-red-500" }, "*")
], -1)
const _hoisted_51 = /*#__PURE__*/_createElementVNode("option", { selected: "" }, "Please select", -1)
const _hoisted_52 = ["value"]
const _hoisted_53 = /*#__PURE__*/_createElementVNode("hr", { class: "mt-6 bg-play-light-gray" }, null, -1)
const _hoisted_54 = { class: "mt-6" }

import { computed, Ref, ref } from "vue";
import { storeToRefs } from "pinia";

import TitleHeader from "@/components/TitleHeader.vue";
import DefaultButton from "@/components/DefaultButton.vue";

import api from "@/api/api";
import router from "@/router";
import { useGlobalStore } from "@/store";
import { Role } from "@/types";


export default /*#__PURE__*/_defineComponent({
  __name: 'NewUser',
  async setup(__props) {

let __temp: any, __restore: any

const globalStore = useGlobalStore();
const { user_roles } = storeToRefs(globalStore);

const isSaving = ref(false);
const role = ref(null) as Ref<Role | null>;

const firstName = ref("");
const lastName = ref("");
const email = ref("");
const mobileNumber = ref("");
const organisation_id = ref(0);
const sub_organisation = ref("");

const addressLine1 = ref("");
const addressLine2 = ref("");
const city = ref("");
const county = ref("");
const postcode = ref("");
const country = ref("");
const add_to_moodle = ref(false);
const add_to_azure = ref(true);
const add_to_brevo = ref(true);

const countries = ((
  ([__temp,__restore] = _withAsyncContext(() => api.misc.listCountries())),
  __temp = await __temp,
  __restore(),
  __temp
)).countries;
const organisations = (
  (
  ([__temp,__restore] = _withAsyncContext(() => api.organisations.listOrganisations({
    page: "all",
  }))),
  __temp = await __temp,
  __restore(),
  __temp
)
).data.organisations;

const filteredOrganisations = computed(() => {
  return organisations.filter(organisation => {
    // If the user has a role that is not allowed in the organisation, we don't want to show the Organisation
    if (organisation.play_included_organisation && ["trainer-organisation", "facilitator-organisation", "l4a-trainer", "l4a-trainee"].includes(role.value?.name as Role["name"])) {
      return false;
    }
    return true;
  });
});

async function saveNewUser() {
  isSaving.value = true;

  // If user has a role that is not allowed in the organisation, we don't want to save the user
  let organisation = filteredOrganisations.value.find(org => org.id === organisation_id.value);

  if (organisation?.play_included_organisation && ["trainer-organisation", "facilitator-organisation", "l4a-trainer", "l4a-trainee"].includes(role.value?.name as Role["name"])) {
    globalStore.toast("ERROR", "You cannot create a user with this role in this organisation");
    isSaving.value = false;
    return;
  }

  if (!country.value) {
    globalStore.toast("ERROR", "Please select a country");
    isSaving.value = false;
    return;
  }

  try {
    const response = await api.users.createUser({
      firstName: firstName.value.trim(),
      lastName: lastName.value.trim(),
      email: email.value.trim(),
      mobileNumber: mobileNumber.value.trim(),
      address_line_1: addressLine1.value.trim(),
      address_line_2: addressLine2.value.trim(),
      city: city.value.trim(),
      county: county.value.trim(),
      postcode: postcode.value.trim(),
      country: country.value.trim(),
      roles: [Number(role.value!.id)],
      organisation_id: organisation_id.value.toString(),
      add_to_moodle: add_to_moodle.value,
      add_to_azure: add_to_azure.value,
      add_to_brevo: add_to_brevo.value,
      sub_organisation: sub_organisation.value.trim(),
    });

    if (response.meta.status === 200) {
      globalStore.toast("SUCCESS", "User created successfully");
      return router.push({ name: "User_Profile", params: { id: response.data.user.id } });
    }
  } catch (e) {
    isSaving.value = false;
    console.log(e);
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createVNode(TitleHeader, {
        title: _ctx.$t('add-a-new-user')
      }, null, 8, ["title"])
    ]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _withDirectives(_createElementVNode("select", {
          id: "user-type",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(role) ? (role).value = $event : null)),
          class: "text-black border rounded w-full md:w-1/3 focus:outline-none focus:shadow-outline-primary font-normal transition duration-50 ease-in px-3 py-1.5 h-10 border-gray-600 capitalize"
        }, [
          _hoisted_4,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(user_roles), (role) => {
            return (_openBlock(), _createElementBlock("option", {
              value: role,
              class: "capitalize",
              key: role.id
            }, _toDisplayString(_ctx.$t(role.name)), 9, _hoisted_5))
          }), 128))
        ], 512), [
          [_vModelSelect, _unref(role)]
        ])
      ]),
      _hoisted_6
    ]),
    _createElementVNode("div", _hoisted_7, [
      _hoisted_8,
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _hoisted_11,
          _withDirectives(_createElementVNode("input", {
            type: "text",
            id: "firstname",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((firstName).value = $event)),
            class: "block w-full h-10 py-2 text-gray-900 border border-gray-600 rounded",
            placeholder: "",
            required: ""
          }, null, 512), [
            [_vModelText, firstName.value]
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _hoisted_13,
          _withDirectives(_createElementVNode("input", {
            type: "text",
            id: "lastname",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((lastName).value = $event)),
            class: "block w-full h-10 py-2 text-gray-900 border border-gray-600 rounded",
            placeholder: "",
            required: ""
          }, null, 512), [
            [_vModelText, lastName.value]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", _hoisted_15, [
          _hoisted_16,
          _withDirectives(_createElementVNode("select", {
            id: "subscription",
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((organisation_id).value = $event)),
            class: "text-black border rounded w-full capitalize focus:outline-none focus:shadow-outline-purple font-normal transition duration-50 ease-in px-3 py-1.5 h-10 border-gray-600"
          }, [
            _hoisted_17,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(filteredOrganisations), (organisation) => {
              return (_openBlock(), _createElementBlock("option", {
                value: organisation.id,
                key: organisation.id,
                class: "capitalize"
              }, _toDisplayString(organisation.name), 9, _hoisted_18))
            }), 128))
          ], 512), [
            [_vModelSelect, organisation_id.value]
          ])
        ]),
        _createElementVNode("div", _hoisted_19, [
          _hoisted_20,
          _withDirectives(_createElementVNode("input", {
            type: "text",
            id: "sub_organisation",
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((sub_organisation).value = $event)),
            class: "block w-full h-10 py-2 text-gray-900 border border-gray-600 rounded",
            placeholder: ""
          }, null, 512), [
            [_vModelText, sub_organisation.value]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_21, [
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("label", _hoisted_23, [
            _createTextVNode(_toDisplayString(_ctx.$t("email-address")) + " ", 1),
            _hoisted_24
          ]),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            id: "email-address",
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((email).value = $event)),
            class: "block w-full h-10 py-2 text-gray-900 border border-gray-600 rounded",
            placeholder: "",
            required: ""
          }, null, 512), [
            [_vModelText, email.value]
          ])
        ]),
        _createElementVNode("div", _hoisted_25, [
          _createElementVNode("label", _hoisted_26, _toDisplayString(_ctx.$t("mobile-number")), 1),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            id: "email-address",
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((mobileNumber).value = $event)),
            class: "block w-full h-10 py-2 text-gray-900 border border-gray-600 rounded",
            placeholder: "mobile no."
          }, null, 512), [
            [_vModelText, mobileNumber.value]
          ])
        ])
      ]),
      _hoisted_27,
      _createElementVNode("div", _hoisted_28, [
        _hoisted_29,
        _createElementVNode("div", _hoisted_30, [
          _withDirectives(_createElementVNode("input", {
            type: "checkbox",
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((add_to_azure).value = $event)),
            class: "mt-2 rounded"
          }, null, 512), [
            [_vModelCheckbox, add_to_azure.value]
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("label", null, _toDisplayString(_ctx.$t("create-account-in-azure")), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_31, [
          _withDirectives(_createElementVNode("input", {
            type: "checkbox",
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((add_to_brevo).value = $event)),
            class: "mt-2 rounded"
          }, null, 512), [
            [_vModelCheckbox, add_to_brevo.value]
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("label", null, _toDisplayString(_ctx.$t("create-account-in-brevo")), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_32, [
          _withDirectives(_createElementVNode("input", {
            type: "checkbox",
            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((add_to_moodle).value = $event)),
            class: "mt-2 rounded"
          }, null, 512), [
            [_vModelCheckbox, add_to_moodle.value]
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("label", null, _toDisplayString(_ctx.$t("create-account-in-moodle")), 1)
          ])
        ])
      ]),
      _hoisted_33
    ]),
    _createElementVNode("div", _hoisted_34, [
      _hoisted_35,
      _createElementVNode("div", _hoisted_36, [
        _createElementVNode("div", _hoisted_37, [
          _hoisted_38,
          _withDirectives(_createElementVNode("input", {
            type: "text",
            id: "addressLine1",
            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((addressLine1).value = $event)),
            class: "block w-full h-10 py-2 text-gray-900 border border-gray-600 rounded",
            placeholder: "",
            required: ""
          }, null, 512), [
            [_vModelText, addressLine1.value]
          ])
        ]),
        _createElementVNode("div", _hoisted_39, [
          _hoisted_40,
          _withDirectives(_createElementVNode("input", {
            type: "text",
            id: "addressLine2",
            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((addressLine2).value = $event)),
            class: "block w-full h-10 py-2 text-gray-900 border border-gray-600 rounded",
            placeholder: "",
            required: ""
          }, null, 512), [
            [_vModelText, addressLine2.value]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_41, [
        _createElementVNode("div", _hoisted_42, [
          _hoisted_43,
          _withDirectives(_createElementVNode("input", {
            type: "text",
            id: "city",
            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((city).value = $event)),
            class: "block w-full h-10 py-2 text-gray-900 border border-gray-600 rounded",
            placeholder: "city",
            required: ""
          }, null, 512), [
            [_vModelText, city.value]
          ])
        ]),
        _createElementVNode("div", _hoisted_44, [
          _hoisted_45,
          _withDirectives(_createElementVNode("input", {
            type: "text",
            id: "county",
            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((county).value = $event)),
            class: "block w-full h-10 py-2 text-gray-900 border border-gray-600 rounded",
            placeholder: "",
            required: ""
          }, null, 512), [
            [_vModelText, county.value]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_46, [
        _createElementVNode("div", _hoisted_47, [
          _hoisted_48,
          _withDirectives(_createElementVNode("input", {
            type: "text",
            id: "postcode",
            "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((postcode).value = $event)),
            class: "block w-full h-10 py-2 text-gray-900 border border-gray-600 rounded",
            placeholder: "",
            required: ""
          }, null, 512), [
            [_vModelText, postcode.value]
          ])
        ]),
        _createElementVNode("div", _hoisted_49, [
          _hoisted_50,
          _withDirectives(_createElementVNode("select", {
            id: "subscription",
            "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((country).value = $event)),
            class: "text-black border rounded w-full capitalize focus:outline-none focus:shadow-outline-purple font-normal transition duration-50 ease-in px-3 py-1.5 h-10 border-gray-600"
          }, [
            _hoisted_51,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(countries), (region) => {
              return (_openBlock(), _createElementBlock("option", {
                value: region.name,
                key: region.id,
                class: "capitalize"
              }, _toDisplayString(region.name), 9, _hoisted_52))
            }), 128))
          ], 512), [
            [_vModelSelect, country.value]
          ])
        ])
      ]),
      _hoisted_53,
      _createElementVNode("div", _hoisted_54, [
        _createVNode(DefaultButton, {
          onAction: saveNewUser,
          type: "primary",
          loading: isSaving.value,
          disabled: false
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Save new User ")
          ]),
          _: 1
        }, 8, ["loading"])
      ])
    ])
  ], 64))
}
}

})